import type { RouterConfig } from "@nuxt/schema";
import type { RouteRecordRaw } from "vue-router";

export default <RouterConfig>{
  routes: (_routes) => {
    const subdomain = getSubdomain();
    let routes = []

    if (subdomain && subdomain !== 'www' && !subdomain.includes('localhost') && !subdomain.includes('vibes')) {
      routes = transformRoutesForSubdomain(_routes, subdomain);
    } else {
      routes = transformRoutesForSubdomain(_routes, 'main')
    }

    return routes;
  },
};

function getSubdomain(): string | undefined {
  const { ssrContext } = useNuxtApp();
  if (isServer() && ssrContext) {
    const { req } = ssrContext.event.node;
    return req.headers.host?.split(".")[0];
  } else if (isClient()) {
    return window.location.hostname.split(".")[0];
  }
}

function transformRoutesForSubdomain(
  routes: readonly RouteRecordRaw[],
  subdomain: string,
  isChildren: boolean = false
): RouteRecordRaw[] {
  return routes
    .filter((route: RouteRecordRaw) => {
      return isChildren || isUnderDirectory(route, subdomain);
    })
    .map((route: RouteRecordRaw) => {
      const path = isChildren ? route.path : route.path.slice(subdomain.length + 1) || "/"
      const routeName = subdomain === 'app' ? route.name : ((route.name ?? '') as string).slice(subdomain.length + 1)

      return {
        ...route,
        path,
        name: routeName ? routeName : (path === '/' ? 'index' : undefined),
        children: transformRoutesForSubdomain(route.children ?? [], subdomain, true)
      };
    });
}

function isUnderDirectory(route: RouteRecordRaw, directory: string): boolean {
  const { path } = route;
  return path === `/${directory}` || path.startsWith(`/${directory}/`);
}

function isServer(): boolean {
  return import.meta.server;
}

function isClient(): boolean {
  return !!(import.meta.client && window.location.hostname);
}